import { inject } from '@angular/core';
import { CanActivateFn, Router, ActivatedRouteSnapshot, UrlTree } from '@angular/router';

const VALID_USER_TYPES = ['admin', 'company', 'consumer', 'support'];

function defaultRouteForUserType(userType: string): string {
  switch ((userType || '').toLowerCase()) {
    case 'admin':
      return '/portal/admin';
    case 'company':
      return '/portal/company';
    case 'consumer':
    case 'support':
    default:
      return '/portal/dashboard';
  }
}

export const roleGuard: CanActivateFn = (route: ActivatedRouteSnapshot): boolean | UrlTree => {
  const router = inject(Router);

  const allowedRoles: string[] = route.data?.['roles'] || [];
  const userType = (localStorage.getItem('user_type') || '').toLowerCase();

  if (!userType) {
    return router.createUrlTree(['/login']);
  }

  // user_type exists but is NOT one of the 4 known types
  // (tampered/corrupted localStorage, or a stray value) -> treat as
  // untrusted, send to login instead of falling through to dashboard
  if (!VALID_USER_TYPES.includes(userType)) {
    return router.createUrlTree(['/login']);
  }

  // No roles restriction configured on this route -> allow
  if (allowedRoles.length === 0) {
    return true;
  }

  // user_type allowed for this route -> allow
  if (allowedRoles.map(r => r.toLowerCase()).includes(userType)) {
    return true;
  }

  // role mismatch -> send to login instead of their own
  // dashboard, so a consumer poking /portal/admin can't confirm the
  // route exists or bounce anywhere inside the portal 
  return router.createUrlTree(['/login']);
};